export const TOKEN_KEY = `genedata_auth_token${import.meta.env.DEV ? "" : `_${location.pathname.split("/")[1]}`}`;

export const getCredentialsHeaders = (): Map<string, string> => {
  const token = localStorage.getItem(TOKEN_KEY);

  return new Map(
    token
      ? [
          ["Authorization", `Bearer ${token}`],
          ["X-Authorization", `Bearer ${token}`],
        ]
      : undefined,
  );
};
